import classes from "./Country.module.css";

const CountryImage = (props) => {
  return <img className={classes.image} src={props.photo} alt="" />;
};

export default CountryImage;
